module.exports = __webpack_public_path__ + "static/paulina-8b41f73a0916f3fb7d3ebe0eb9eff446.jpg";